import React, { FC } from "react";
import { Alert, Form } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { FormSelectGroup } from "go-form/components/FormSelect";
import {
	SubscriptionApi,
	UpdateSubscriptionApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { PriceConfiguratorContentApi } from "../../../../../../../../services/Api/types";
import { RenderApplicationLogo } from "../../../../../../components/RenderApplicationLogo/RenderApplicationLogo";
import SubscriptionFormStatus from "./SubscriptionFormStatus";

interface Props {
	original: SubscriptionApi;
	estimate?: SubscriptionApi;
	config?: PriceConfiguratorContentApi;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	updateSubscription: UpdateSubscriptionApi;
	handleChangePlan: (familyId: string, planId: string) => void;
	index: number;
}

const ReadonlySubscription: FC<Props> = (props: Props) => {
	const {
		formState: { errors },
		control,
	} = props.form;
	const { t } = useTranslation();
	const familyId = props.original.family_id.toString();
	const familyName = props.original.family_name;
	const planName = props.original.plan_id;
	const billingPeriod = props.original.billing_period;
	const isSubscriptionEditable = true;
	const roPlans = props.config?.plans.filter((plan) => plan.edit_mode === "READ_ONLY");

	const getPlanOptions = () => {
		if (!roPlans) return [];
		return roPlans.map((plan) => {
			return {
				label: plan.name,
				value: plan.plan_id,
			};
		});
	};
	const handleChangePlan = (value: string) => {
		if (!props.config) return;
		props.handleChangePlan(props.config?.family_id, value);
	};
	const isEditablePlan = !!(
		props.config &&
		roPlans &&
		roPlans.some((plan) => plan.plan_id === props.updateSubscription.plan_id)
	);

	return (
		<>
			<div className={`card subscription-card ${!isSubscriptionEditable && "readonly-subscription"}`}>
				<div className={"header"}>
					<RenderApplicationLogo slug={familyId} /> <h5>{familyName} </h5>
					<div className={"d-flex align-items-center"}>
						<SubscriptionFormStatus sub={props.original} />
					</div>
				</div>
				<div className={"body"}>
					<div className={"row"}>
						{/*<FormInput errors={errors} type={"hidden"} register={register}*/}
						{/*           // defaultValue={estimate.status}*/}
						{/*           name={`subscriptions.${props.index}.status`}/>*/}
						{isEditablePlan ? (
							<FormSelectGroup
								label={`${t("modules.subscription.field.license_type.title")}:`}
								errors={errors}
								// defaultValue={estimate.plan_id}
								options={getPlanOptions()}
								getOptionValue={(opt) => opt.value}
								getOptionLabel={(opt) => opt.label}
								name={`subscriptions.${props.index}.plan_id`}
								onChange={(value) => handleChangePlan(value)}
								control={control}
								isClearable={false}
								data-testid={`subscriptions.${props.index}.plan_id`}
							/>
						) : (
							<Form.Group className="form-group">
								<Form.Label>{`${t("modules.subscription.field.license_type.title")}:`}</Form.Label>
								<Form.Control disabled={true} value={planName} />
							</Form.Group>
						)}
						<div className={"subscription-price"}>
							<label className={"form-label"}>{t("modules.subscription.field.price.title")}:</label>
							<Alert variant={"warning"}>
								<strong>
									{props.estimate ? (
										<>
											{FormatMoney(props.estimate.total_money)}/
											{props.estimate.billing_period === "YEARLY" ? "rok" : "mies."}
											{props.estimate.monthly_sub_item &&
												props.estimate.monthly_sub_item.total_money && (
													<>
														{" "}
														+ {FormatMoney(props.estimate.monthly_sub_item.total_money)}/
														{t("modules.subscription.field.monthly_shortcut.title")}
													</>
												)}
										</>
									) : (
										<>~</>
									)}
								</strong>
							</Alert>
						</div>
					</div>
					{/*{(fields.length > 0 || (planAddons && planAddons.length > 0)) &&*/}
					{/*    <YearlyAddons fields={fields} index={props.index} form={props.form}*/}
					{/*                  configAddons={planAddons} estimate={props.estimate} handleRemove={handleRemove}*/}
					{/*                  handleAdd={handleAdd}/>*/}
					{/*}*/}
					{/*{(fields.length > 0 || (configAddons && configAddons.length > 0)) &&*/}
					{/*    <YearlyAddons handleUpdate={handleSave} fields={fields} index={index} form={form}*/}
					{/*                  configAddons={configAddons} sub={estimate} handleRemove={handleRemove}*/}
					{/*                  handleAdd={handleAdd}/>*/}
					{/*}*/}
					{/*{*/}
					{/*    watchedPeriod === "YEARLY" && configSubAddons && configSubAddons.length > 0 &&*/}
					{/*    <MonthlyAddons handleUpdate={handleSave} sub={subscription.monthly_sub_item}*/}
					{/*                   subFields={subFields}*/}
					{/*                   index={index} watchedSubFields={watchedSubFields}*/}
					{/*                   form={form} configSubAddons={configSubAddons}*/}
					{/*                   handleAddSubAddon={handleAddSubAddon}*/}
					{/*                   isSubscriptionEditable={isSubscriptionEditable}*/}
					{/*                   handleRemoveSubAddon={handleRemoveSubAddon}*/}
					{/*    />*/}
					{/*}*/}
				</div>
			</div>
		</>
	);
};
export default ReadonlySubscription;
